import { DataBean } from "../DataBean";

export class TransportGuideInfo extends DataBean {

    public async getTransportGuideItemValues(idTransportGuide: any, transportGuideDate: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.transportguides.TransportGuideItem_getTransportGuideItemValues_Number_java.util.Date", [idTransportGuide, transportGuideDate]);
    }

}